import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import JoinImg from "../../../../../../assets/images/fanGroup/unknown.png";
import JoiningRequestModalStar from "./JoiningRequestModalStar";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";

const JoiningRequestStar = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [modalShow, setModalShow] = React.useState(false);
  const [checkApprove, setCheckApprove] = useState(false);
  const [loading, setLoading] = useState(true);
  const [singleInfo, setSingleInfo] = useState([]);

  let { slug } = useParams();
  const [fanMember, setFanMember] = useState([]);

  useEffect(() => {
    axios.get(`/api/star/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanMember(res.data.fanMember);
        if (res.data.fanMember.length) {
          setLoading(false);
        }
      }
    });
  }, [slug]);

  function handleIdCheck(id) {
    axios.post(`/api/star/fan/member/approve/${id}`).then((res) => {
      if (res.status === 200) {
        setCheckApprove(true);
        swal("Welcome", res.data.message, "success");
        // history.push('/superstar-admin/fan-group');
      }
    });
  }

  if (checkApprove) {
    axios.get(`/api/star/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanMember(res.data.fanMember);
      }
    });
    setCheckApprove(false);
  }

  return (
    <>
      <div className="row my-3">
        <div className="container-fluid">
          <div className="card card-bg">
            <div className="card-body">
              <h5 className="text-light">Approve Joining Member</h5>

              {loading ? (
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <div className="row">
                    {[1, 2].map((data) => (
                      <div className="col-md-12 mb-4 ">
                        <div className="rounded">
                          <div className="bg-dark py-3 px-2">
                            <Skeleton width="100%" className="" height={25} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </SkeletonTheme>
              ) : (
                <Table
                  striped
                  bordered
                  hover
                  variant="dark"
                  style={{ fontSize: "12px" }}
                >
                  <thead>
                    <tr>
                      <th>Members Name</th>
                      <th>Own Star Name</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fanMember.map((member, i) => (
                      <tr>
                        <td>
                          <img
                            src={imageCdnUrl + member.user?.image}
                            className="mx-1"
                            alt=""
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "50%;",
                            }}
                          />{" "}
                          {member.user?.first_name} {member.user?.last_name}
                        </td>
                        <td className="pt-3">{member.star_name}</td>

                        <td className="text-center">
                          {" "}
                          <i
                            className="btn fa-solid fa-eye text-warning "
                            onClick={() => {
                              setSingleInfo(member);
                              setModalShow(true);
                            }}
                          ></i>{" "}
                          <i
                            className="fa-solid fa-square-plus text-success btn"
                            title="Approve Now"
                            onClick={() => handleIdCheck(member.id)}
                          ></i>
                          <JoiningRequestModalStar
                            show={modalShow}
                            member={singleInfo}
                            onHide={() => setModalShow(false)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoiningRequestStar;
